const games = [
  {
    name: "Crazy Table Tennis",
    tag: "Smash · Rally · Predict",
    body: "Smash challenges, double-point rallies, team scoring.",
  },
  {
    name: "Crazy Carrom",
    tag: "Strategy · Leaderboard",
    body: "Strategic team play, reward challenges, leaderboards.",
  },
  {
    name: "Double Wicket Cricket",
    tag: "Challenge Cricket",
    body: "Bonus scoring and team collaboration mechanics.",
  },
  {
    name: "Crazy Hide & Seek",
    tag: "Office · City",
    body: "Clue trails, team missions, role-switching, collaborative problem solving.",
  },
];

export default function CrazySports() {
  return (
    <section
      id="crazy"
      data-testid="crazy-section"
      className="relative py-28 lg:py-36 border-b border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between mb-14 flex-wrap gap-6">
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#dc2626] mb-4 flex items-center gap-3">
              <span className="w-8 h-px bg-[#dc2626]" /> 07 · Crazy Sports · Mass Engagement
            </div>
            <h2 className="font-display uppercase font-black text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
              Fun. Competition.
              <br />
              <span className="text-neutral-500">Humor. Connection.</span>
            </h2>
          </div>
          <div className="font-mono text-xs text-neutral-500 max-w-sm">
            Short, scoreable formats built for lunch breaks, offsites and full-day
            festivals.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {games.map((g, i) => (
            <div
              key={i}
              data-testid={`crazy-card-${i}`}
              className="relative bg-gradient-to-br from-[#0a0a0a] to-[#050505] border border-white/10 p-6 min-h-[220px] flex flex-col justify-between hover:border-[#f59e0b]/60 transition-colors group"
            >
              <div className="absolute top-4 right-4 font-mono text-[10px] text-neutral-600 group-hover:text-[#f59e0b] transition-colors">
                {String(i + 1).padStart(2, "0")}/04
              </div>
              <div>
                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#f59e0b] mb-3">
                  {g.tag}
                </div>
                <h3 className="font-display uppercase font-black text-xl md:text-2xl tracking-tight leading-tight">
                  {g.name}
                </h3>
              </div>
              <p className="text-sm text-neutral-400 leading-relaxed">{g.body}</p>
            </div>
          ))}
        </div>

        {/* Phish or Foul callout */}
        <div
          data-testid="phish-or-foul"
          className="mt-10 border border-[#dc2626]/40 bg-[#dc2626]/[0.04] p-8 md:p-10 grid grid-cols-12 gap-8 items-center"
        >
          <div className="col-span-12 lg:col-span-7">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#dc2626] mb-3">
              INSIDE THE LINEUP · Phish or Foul
            </div>
            <h3 className="font-display uppercase font-black text-3xl md:text-4xl leading-[0.95]">
              Gamified cybersecurity awareness. <span className="text-neutral-500">3× more effective.</span>
            </h3>
          </div>
          <div className="col-span-12 lg:col-span-5 grid grid-cols-3 gap-3">
            {[
              ["91%", "attacks start via phishing"],
              ["3×", "vs. standard CBT"],
              ["₹0", "extra infrastructure"],
            ].map(([n, l], i) => (
              <div key={i} className="bg-black border border-white/10 p-4 text-center">
                <div className="font-display font-black text-2xl">{n}</div>
                <div className="mt-1 font-mono text-[9px] uppercase tracking-[0.15em] text-neutral-500 leading-tight">
                  {l}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
